import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthService } from 'app/core/auth/auth.service';
import { WithdrawLimitsService } from 'app/core/withdraw-limits/withdraw-limits.service';
import { WithdrawService } from 'app/core/withdraw/withdraw.service';
import { firstValueFrom } from 'rxjs';

@Component({
    selector: 'app-withdraw-modal-end-transaction',
    templateUrl: './withdraw-modal-end-transaction.component.html',
    styleUrls: ['./withdraw-modal-end-transaction.component.scss'],
})
export class WithdrawModalEndTransactionComponent implements OnInit {
    public selected: any = 'None';
    public isUnique: boolean = false;
    public uniquePaymentSystemData: any = null;
    public isBank: boolean = false;
    public paymentButtonMappings = {
        cashforo_bankwithdraw: [
            'gurupay',
            'inpay',
            'Pion_SEPA',
            'mifinity-sepa',
            'aifory_SEPA',
        ],
        inpay_withdraw: [
            'gurupay',
            'inpay',
            'Pion_SEPA',
            'mifinity-sepa',
            'aifory_SEPA',
        ],
    };
    public banks = [
        {
            name: 'gurupay',
            bannedCountries: ['ES', 'GR', 'LT', 'CY'],
            limit: '10 000',
        },
        // {
        //     name: 'inpay',
        //     bannedCountries: ['FR', 'DK', 'NO', 'CH', 'LT', 'RU', 'BY', 'SE'],
        //     limit: '10 000',
        // },
        {
            name: 'Pion_SEPA',
            bannedCountries: [
                'NO',
                'GR',
                'FR',
                'GB',
                'ES',
                'CY',
                'LT',
                'MT',
                'NL',
                'SK',
            ],
            limit: '10 000',
        },
        {
            name: 'mifinity-sepa',
            bannedCountries: [],
            limit: '10 000',
        },
        {
            name: 'aifory_SEPA',
            bannedCountries: [],
            limit: '10 000',
        },
    ];

    public bankCountry: string;
    public lastWithdraws: any = [
        // { date: new Date(), amount: 'EUR 1245,11' },
        // { date: new Date(), amount: 'RUB 5000000,00' },
    ];
    ibanValue: string;
    fieldsToDisplay = [
        { label: 'Amount', key: 'amount' },
        { label: 'Currency', key: 'currency' },
        { label: 'First Name', key: 'firstName' },
        { label: 'Last Name', key: 'lastName' },
        { label: 'Customer country', key: 'country' },
        { label: 'IBAN', key: 'iban' },
        { label: 'iban Number', key: 'ibanNumber' },
        { label: 'BIC/SWIFT', key: 'swift' },
        { label: 'Bank Country', key: 'bankCountry' },
    ];
    private uniquePaymentSystemsArray: Array<{
        paymentSystem: string;
        valuesArray: Array<{ value: string; nameSpace: string }>;
        fieldValuesName: string;
    }> = [
        {
            paymentSystem: 'skrill',
            valuesArray: [
                { value: 'EEA', nameSpace: 'EEA' },
                { value: 'ROW', nameSpace: 'ROW' },
            ],
            fieldValuesName: 'withdrawWallet',
        },
        // {
        //     paymentSystem: 'inpay_withdraw',
        //     valuesArray: [
        //         { value: 'inpay', nameSpace: 'Inpay' },
        //         { value: 'gurupay', nameSpace: 'Gurupay' },
        //     ],
        //     fieldValuesName: 'paymentSystem',
        // },
        {
            paymentSystem: 'cashforo_interac',
            valuesArray: [
                { value: 'ETO', nameSpace: 'ETO' },
                { value: 'ACH', nameSpace: 'ACH' },
            ],
            fieldValuesName: 'paymentSystem',
        },
        // {
        //     paymentSystem: 'cashforo_mastercard_2',
        //     valuesArray: [
        //         { value: 'pion', nameSpace: 'Pion' },
        //         { value: 'br-ww-out', nameSpace: 'BlackRabbit' },
        //         { value: 'colibrix', nameSpace: 'Colibrix' },
        //     ],
        //     fieldValuesName: 'paymentSystem',
        // },
        // {
        //     paymentSystem: 'cashforo_visa_2',
        //     valuesArray: [
        //         { value: 'pion', nameSpace: 'Pion' },
        //         { value: 'br-ww-out', nameSpace: 'BlackRabbit' },
        //         { value: 'colibrix', nameSpace: 'Colibrix' },
        //     ],
        //     fieldValuesName: 'paymentSystem',
        // },
        // {
        //     paymentSystem: 'cashforo_creditcard_blackrabbitru',
        //     valuesArray: [
        //         { value: 'BR_RUB_FTD', nameSpace: 'BR FTD Account' },
        //         { value: 'BR_RUB_WL', nameSpace: 'BR WL Account' },
        //     ],
        //     fieldValuesName: 'paymentSystem',
        // },
    ];

    protected availableBalance: number;
    protected isAvailable: boolean = false;
    protected isLoading: boolean = true;

    constructor(
        public dialogRef: MatDialogRef<WithdrawModalEndTransactionComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private withdrawService: WithdrawService,
        private withdrawLimitsService: WithdrawLimitsService,
        private authService: AuthService
    ) {
        this.getBalanceByPU(this.data.paymentSystem);
    }

    ngOnInit(): void {
        this.isUnique = this.isPaymentUnique(this.data.paymentSystem);

        // Disabled for testing cascade
        // setTimeout(() => {
        //     this.isBankPayment(this.data.paymentSystem);
        // }, 0);

        if (this.data.metadata.iban || this.data.metadata.ibanNumber) {
            this.fieldsToDisplay = this.fieldsToDisplay.filter(
                (field) => field.key !== 'ibanNumber'
            );
            this.ibanValue =
                this.data.metadata.iban || this.data.metadata.ibanNumber;
            this.bankCountry = this.ibanValue.slice(0, 2);

            this.data.metadata.bankCountry = this.bankCountry;
        }
    }

    async getBalanceByPU(paymentSystemSlug: string): Promise<void> {
        const balance: any = await firstValueFrom(
            this.withdrawLimitsService.getLimitsByPU(paymentSystemSlug)
        );
        const withdrawAmount = this.data.metadata.amount;

        this.availableBalance = balance.limit;

        this.isLoading = false;
        if (
            balance.message === 'Payment unit does not exist' ||
            withdrawAmount < this.availableBalance
        ) {
            this.isAvailable = true;
        }
    }

    isBankPayment(paymentSystem: string): void {
        if (this.paymentButtonMappings.hasOwnProperty(paymentSystem)) {
            this.isBank = true;
            this.fetchWithdrawHistory();
            this.filterBanksByPaymentSystem(paymentSystem);
            return;
        }
        this.isBank = false;
    }

    filterBanksByPaymentSystem(paymentSystem: string): void {
        this.banks = this.banks.filter((bank) =>
            this.paymentButtonMappings[paymentSystem].includes(bank.name)
        );
    }

    fetchWithdrawHistory(): void {
        // Default two years withdraw history from now
        const withdrawHistoryRange = {
            from: new Date(new Date().setFullYear(new Date().getFullYear() - 2))
                .toISOString()
                .slice(0, 10),
            to: new Date().toISOString().slice(0, 10),
        };

        firstValueFrom(
            this.withdrawService.getWithdrawHistorybyIban(
                this.ibanValue,
                withdrawHistoryRange.from,
                withdrawHistoryRange.to
            )
        )
            .then((lastWithdraws) => {
                this.lastWithdraws = this.transformWithdrawData(lastWithdraws);
            })
            .catch((error) => {
                console.error(error);
            });
    }

    transformWithdrawData(lastWithdraws: any) {
        return lastWithdraws.data.map((action) => ({
            date: new Date(action.dateTime).toISOString(),
            amount: `${action.metadata.currency} ${parseFloat(
                action.metadata.amount
            ).toFixed(2)}`,
            paymentSystem: action.metadata.paymentSystem,
            withdrawId: action.withdrawId,
        }));
    }

    isPaymentUnique(paymentSystem) {
        const result = this.uniquePaymentSystemsArray.find(
            (element) => paymentSystem.indexOf(element.paymentSystem) > -1
        );
        this.uniquePaymentSystemData = result;
        return !!result;
    }

    resetSelection() {
        this.selected = 'None';
    }

    start() {
        const operator = this.getOperator();

        this.dialogRef.close({
            isSubmitted: true,
            data: this.selected,
            fieldName: this.uniquePaymentSystemData?.fieldValuesName,
            bankTransfer: this.isBank,
            operator: operator.username,
        });
    }

    closeDialog() {
        this.dialogRef.close({ isSubmitted: false, data: this.selected });
    }

    getOperator(): any {
        return this.authService.getJwtUserInfo();
    }
}
